<template>
  <el-container class="home-container" :class="{ 'nav-hidden': shouldAutoHideNav && navHidden }">
    <!-- Hover zone to show navbar when hidden -->
    <div
      v-if="shouldAutoHideNav && navHidden"
      class="nav-hover-zone"
      @mouseenter="showNavFromHoverZone"
    ></div>
    <el-menu
      mode="horizontal"
      class="nav-menu"
      :class="{ 'nav-menu-hidden': shouldAutoHideNav && navHidden }"
      :router="true"
      :default-active="defaultActiveTab"
      @mouseenter.native="showNav"
      @mouseleave.native="hideNavDelayed"
    >
      <div class="logo-item">
        <div class="logo-container">
          <router-link to="/about" class="logo-link">
            <div class="logo-wrapper">
              <img :src="branding.logo" :alt="branding.logoAlt" class="logo-img"/>
              <span class="logo-text">{{ brandingText }}</span>
            </div>
          </router-link>
        </div>
      </div>
      <!-- <el-menu-item index="/about">
        <span>About</span>
      </el-menu-item> -->
      <!-- <el-menu-item index="/square">
        <span>Square</span>
      </el-menu-item>
      <el-menu-item index="/people">
        <span>People</span>
      </el-menu-item> -->
      <!-- <el-menu-item index="/my-knowit" v-if="creator_functionality_level === 'Premium'">
        <span>My Knowits</span>
      </el-menu-item>
      
      <el-menu-item index="/my-collections">
        <span>My Collections</span>
      </el-menu-item> -->
      <!-- <el-menu-item index="/todos">
        <span>Todos</span>
      </el-menu-item> -->
      <el-menu-item index="/plaza">
        <span>Plaza</span>
      </el-menu-item>

      <!-- <el-menu-item index="/inbox">
        <span>Inbox</span>
      </el-menu-item> -->

      <el-menu-item index="/my-knowits">
        <span>Knowit Cards</span>
      </el-menu-item>
      <el-menu-item index="/my-learning">
        <span>My Learning</span>
      </el-menu-item>
      <!-- My Activity moved to user dropdown menu -->
      <div v-if="isCreatorAccount" class="menu-divider"></div>
      <el-menu-item index="/my-curation" v-if="isCreatorAccount" class="creator-menu-item">
        <span>My Curation</span>
      </el-menu-item>
      <div style="flex: 1"></div>

      <!-- Search Bar -->
      <div class="search-bar-container" v-if="isLoggedIn">
        <el-input
          v-model="searchQuery"
          placeholder="Search..."
          prefix-icon="el-icon-search"
          clearable
          @keyup.enter.native="handleSearch"
          @keydown.native.stop
          @clear="handleSearchClear"
          class="search-input"
        ></el-input>
      </div>

      <el-menu-item v-if="!isLoggedIn">
        <el-button type="primary" @click="goToLogin">Login</el-button>
      </el-menu-item>
      <div v-else class="user-menu-item" style="display: flex; align-items: center; padding: 0 12px; height: 60px; cursor: pointer;">
        <el-dropdown trigger="click" @command="handleCommand" @visible-change="handleDropdownVisibleChange">
          <div class="user-dropdown-link">
            <el-avatar 
              :size="32" 
              :src="userInfo.user_avatar_address_small" 
              :style="{
                border: getBorderStyleByUserType(userInfo.user_type),
                backgroundColor: userInfo.user_avatar_address_small && userInfo.user_avatar_address_small !== '' && userInfo.user_avatar_address_small !== 'undefined' ? 'white' : '#e0e0e0',
                color: '#409EFF'
              }"
            >
              {{ userInfo.user_avatar_address_small && userInfo.user_avatar_address_small !== '' && userInfo.user_avatar_address_small !== 'undefined' ? '' :  userName?.charAt(0) }}
            </el-avatar>
            <span class="user-name">{{ userName }}</span>
            <el-tag
              v-if="$store.state.platformSubscription?.active"
              :type="$store.state.platformSubscription?.tier === 'premium' ? 'warning' : ''"
              size="mini"
              effect="dark"
              class="subscription-badge"
            >
              {{ $store.state.platformSubscription?.tier === 'premium' ? 'Premium' : 'Subscribed' }}
            </el-tag>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- Achievement Stats Section (hidden) -->
            <div v-if="false" class="achievement-section">
              <h4 class="achievement-title">Achievements</h4>
              <div class="achievement-stats">
                <div class="achievement-stat-item">
                  <i class="el-icon-document"></i>
                  <span class="stat-label">Knowit Cards</span>
                  <span class="stat-value">{{ userInfo.achievement_stats?.private_card_count || 0 }}</span>
                </div>
                <div class="achievement-stat-item">
                  <i class="el-icon-view"></i>
                  <span class="stat-label">Stacks Viewed</span>
                  <span class="stat-value">{{ userInfo.achievement_stats?.post_view_count || 0 }}</span>
                </div>
                <div class="achievement-stat-item">
                  <i class="el-icon-question"></i>
                  <span class="stat-label">Quizzes Answered</span>
                  <span class="stat-value">{{ userInfo.achievement_stats?.quiz_answer_count || 0 }}</span>
                </div>
              </div>
            </div>

            <div
              v-if="isCreatorAccount && creator_functionality_level && creator_functionality_level !== 'None'"
              class="creator-level-display"
            >
              <span class="creator-label-text">Creator Program:</span>
              <el-tag
                :type="getCreatorLevelTagType(creator_functionality_level)"
                size="small"
              >
                {{ creator_functionality_level }}
              </el-tag>
            </div>
            <el-dropdown-item command="subscription">
              <i class="el-icon-medal"></i> Subscription
            </el-dropdown-item>
            <el-dropdown-item command="profile">
              <i class="el-icon-user"></i> My Profile
            </el-dropdown-item>
            <el-dropdown-item command="pulses" v-if="creator_functionality_level === 'Pro' || creator_functionality_level === 'Premium'">
              <i class="el-icon-data-line"></i> My Pulses
            </el-dropdown-item>
            <el-dropdown-item command="activity">
              <i class="el-icon-notebook-2"></i> My Activities
            </el-dropdown-item>
            <el-dropdown-item command="starredItems">
              <i class="el-icon-star-off"></i> Starred Items
            </el-dropdown-item>
            <el-dropdown-item command="certificates">
              <i class="el-icon-trophy"></i> My Certificates
            </el-dropdown-item>
            <el-dropdown-item command="workflows" v-if="creator_functionality_level === 'Supreme'">
              <i class="el-icon-connection"></i> My Workflows
            </el-dropdown-item>
            <li class="dropdown-divider"></li>
            <el-dropdown-item command="switchAccount">
              <i class="el-icon-refresh"></i> Switch Accounts
            </el-dropdown-item>
            <el-dropdown-item command="logout">
              <i class="el-icon-switch-button"></i> Logout
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>
    
    <router-view></router-view>

    <!-- Login Dialog -->
    <AuthDialog 
      :visible.sync="loginDialogVisible"
      :initial-mode="'login'"
      @login-success="handleLoginSuccess"
      @update:visible="handleAuthDialogClose"
    />

    <el-dialog
      title="Switch Account"
      :visible.sync="switchAccountDialogVisible"
      width="500px"
      center
      :close-on-click-modal="false"
    >
      <div v-if="availableAccounts.length > 0" class="account-list">
        <div v-for="account in availableAccounts" :key="account.id" class="account-item">
          <el-avatar
            :size="40"
            :src="account.user_avatar_address_small"
            :style="{
              border: getBorderStyleByUserType(account.user_type),
              backgroundColor: account.user_avatar_address_small ? 'white' : '#e0e0e0'
            }"
          >
            {{ !account.user_avatar_address_small ? account.user_name?.charAt(0)?.toUpperCase() : '' }}
          </el-avatar>
          <div class="account-info">
            <span class="account-name">{{ account.user_name || 'Unnamed User' }}</span>
            <span class="account-email">{{ account.user_email || '' }}</span>
            <span class="account-type">{{ formatUserType(account.user_type) }}</span>
          </div>
          <div class="account-actions">
            <el-button
              v-if="account.id !== currentAccountId"
              type="primary"
              size="small"
              @click="switchToAccount(account)"
            >
              Switch
            </el-button>
            <el-tag v-else type="success" size="small">Current</el-tag>
            <el-dropdown trigger="click" @command="(command) => handleAccountCommand(command, account)">
              <el-button
                type="text"
                icon="el-icon-more"
                size="small"
                class="account-more-btn"
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout">
                  <i class="el-icon-switch-button"></i> Log out this account
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div v-else class="no-accounts">
        <i class="el-icon-user" style="font-size: 48px; color: #909399;"></i>
        <p style="color: #909399; margin-top: 10px;">No other accounts available</p>
      </div>
      <div class="new-account-section">
        <el-button type="primary" @click="loginNewAccount" icon="el-icon-plus">
          Add Another Account
        </el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import Cookie from 'js-cookie'
import { getRequest, postRequest } from '@/apis/front'
import AuthDialog from '@/components/AuthDialog.vue'
import multiAccountManager from '@/utils/multiAccountManager'
import branding from '@/config/branding'

export default {
  name: 'Home',
  components: {
    AuthDialog
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.user_id
    },
    userInfo() {
      return this.$store.state.user_info || {}
    },
    userName() {
      return this.userInfo.user_name || ''
    },
    defaultActiveTab() {
      return this.$route.path
    },
    creator_functionality_level() {
      return this.$store.state.user_info?.creator_functionality_level || 'None'
    },
    account_role() {
      return this.$store.state.user_info?.account_role || 'subscriber'
    },
    isCreatorAccount() {
      return this.account_role === 'creator'
    },
    shouldAutoHideNav() {
      return this.$route.meta?.autoHideNav === true
    },
    brandingText() {
      if (this.branding.name === 'LearningFirst') {
        return 'LearningFirst'
      }
      return 'LearningFirst'
    }
  },
  data() {
    return {
      branding,
      switchAccountDialogVisible: false,
      availableAccounts: [],
      loginDialogVisible: false,
      searchQuery: '',
      currentAccountId: null,
      navHidden: false,
      navHideTimeout: null
    }
  },
  created() {
    // Initialize account from localStorage if needed
    this.$store.dispatch('initializeAccount')

    // Fetch subscription status for nav bar badge
    if (this.$store.state.user_id && !this.$store.state.platformSubscription) {
      this.$store.dispatch('fetchPlatformSubscription')
    }

    if (this.shouldCheckUserName()) {
      this.checkUserName()
    }
  },
  watch: {
    // Watch for changes in the user info to ensure navbar updates
    userInfo: {
      handler(newVal, oldVal) {
        // Force update when user info changes
        this.$forceUpdate()
      },
      deep: true
    },
    // Watch route changes to auto-hide nav on specific pages
    '$route': {
      handler(newRoute) {
        if (newRoute.meta?.autoHideNav) {
          // Auto-hide after a short delay when entering the page
          this.hideNavDelayed()
        } else {
          // Show navbar on other pages
          this.navHidden = false
          if (this.navHideTimeout) {
            clearTimeout(this.navHideTimeout)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    showNav() {
      if (this.navHideTimeout) {
        clearTimeout(this.navHideTimeout)
        this.navHideTimeout = null
      }
      this.navHidden = false
    },
    showNavFromHoverZone() {
      this.showNav()
      // If mouse doesn't actually enter the navbar (just briefly passed through
      // the hover zone), schedule auto-hide as fallback. The navbar's own
      // @mouseenter will cancel this timeout if the mouse moves into it.
      this.hideNavDelayed()
    },
    hideNavDelayed() {
      if (!this.shouldAutoHideNav) return
      if (this.navHideTimeout) {
        clearTimeout(this.navHideTimeout)
      }
      this.navHideTimeout = setTimeout(() => {
        this.navHidden = true
      }, 1000) // Hide after 1 second
    },
    handleCommand(command) {
      switch (command) {
        case 'logout':
          this.logout()
          break
        case 'profile':
          this.$router.push({
            path: '/profile',
            query: { id: this.$store.state.user_id }
          }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
          break
        case 'myKnowit':
          this.$router.push('/my-knowit').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
          break
        case 'myCollections':
          this.$router.push('/my-collections').then(() => {
            window.location.reload();
          }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
          break

        case 'subscription':
          this.$router.push('/platform-subscription').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
          break
        case 'switchAccount':
          this.showSwitchAccountDialog()
          break
        case 'pulses':
          this.$router.push('/my-pulses').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
          break
        case 'activity':
          this.$router.push('/my-activity').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
          break
        case 'starredItems':
          this.$router.push('/starred-items').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
          break
        case 'workflows':
          this.$router.push('/workflows').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
          break
        case 'certificates':
          this.$router.push('/my-certificates').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
          break
      }
    },
    logout() {
      this.$confirm('Are you sure you want to log out of this account?', 'Logout', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logOut').then((res) => {
          location.reload()
        })
      }).catch(() => {
        // User cancelled logout
      })
    },
    goToNewPost() {
      localStorage.setItem('editPostId', '')
      if (this.$route.path === '/new-knowit') {
        location.reload()
      } else {
        this.$router.push('/new-knowit')
      }
    },
    goToLogin() {
      this.loginDialogVisible = true
    },
    getOnboardingCompletedKey(userId = this.$store.state.user_id) {
      return userId ? `onboardingCompleted:${userId}` : 'onboardingCompleted'
    },
    shouldCheckUserName() {
      const currentPath = this.$route.path
      const hasPendingRedirect = !!localStorage.getItem('postLoginRedirect')
      const onboardingCompleted = localStorage.getItem(this.getOnboardingCompletedKey()) === 'true'

      return this.isLoggedIn &&
        !!this.$route.meta?.requiresAuth &&
        currentPath !== '/onboarding' &&
        currentPath !== '/personal' &&
        !hasPendingRedirect &&
        !onboardingCompleted
    },
    checkUserName() {
      const userName = (this.userName || '').trim()

      if (this.shouldCheckUserName() && !userName) {
        this.$router.push({
          path: '/onboarding',
          query: { redirect: this.$route.fullPath }
        })
      }
    },
    handleDropdownVisibleChange(visible) {
      // Fetch achievement stats when dropdown is opened
      if (visible) {
        this.fetchAchievementStats()
      }
    },
    async fetchAchievementStats() {
      try {
        const response = await postRequest('getUserAchievementStats', {
          user_id: this.$store.state.user_id
        })

        if (response.data.code === 0) {
          this.$store.commit('setAchievementStats', response.data.data)
        }
      } catch (error) {
        console.error('Failed to fetch achievement stats:', error)
      }
    },
    showSwitchAccountDialog() {
      this.availableAccounts = multiAccountManager.getAllAccounts()
      this.currentAccountId = multiAccountManager.getCurrentAccountId()
      this.switchAccountDialogVisible = true
    },
    async switchToAccount(account) {
      try {
        this.$message.info('Switching account...')
        await this.$store.dispatch('switchAccount', account.id)
        this.switchAccountDialogVisible = false
        // Navigate to My Curation (this is the creator app)
        this.$router.push('/my-curation')
        setTimeout(() => {
          location.reload()
        }, 500)
      } catch (error) {
        this.$message.error('Failed to switch account')
      }
    },
    loginNewAccount() {
      this.switchAccountDialogVisible = false
      this.loginDialogVisible = true
    },
    manageAccounts() {
      this.switchAccountDialogVisible = false
      this.$router.push('/profile')
    },
    formatUserType(type) {
      const typeMap = {
        'individual': 'Individual',
        'institution': 'Institution',
        'agent': 'Agent'
      }
      return typeMap[type] || 'Individual'
    },
    getBorderStyleByUserType(userType) {
      // Default to Individual if not set
      const type = userType || 'individual';

      switch(type) {
        case 'individual':
          return '1px solid #1890ff'; // Theme blue border
        case 'institution':
          return '1px solid #67C23A'; // Green border for institutions
        case 'agent':
          return '1px solid #E6A23C'; // Orange border for agents
        default:
          return '1px solid #e0e0e0'; // Default gray border
      }
    },
    getCreatorLevelTagType(level) {
      switch(level) {
        case 'Supreme':
          return 'danger'  // Red
        case 'Premium':
          return 'warning'  // Orange
        case 'Basic':
          return 'info'  // Gray
        default:
          return ''
      }
    },
    handleLoginSuccess() {
      this.loginDialogVisible = false
      location.reload()
    },
    handleAuthDialogClose(visible) {
      this.loginDialogVisible = visible
    },
    handleSearch() {
      // Handle search functionality
      if (this.searchQuery.trim()) {
        console.log('Searching for:', this.searchQuery)
        // Navigate to search results page
        this.$router.push({
          path: '/search',
          query: { q: this.searchQuery }
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
    },
    handleSearchClear() {
      this.searchQuery = ''
      // Handle clearing search results if needed
      console.log('Search cleared')
    },
    handleAccountCommand(command, account) {
      if (command === 'logout') {
        this.logoutAccount(account)
      }
    },
    logoutAccount(account) {
      this.$confirm(
        `Are you sure you want to log out "${account.user_name || 'this account'}"? This will remove the account from your saved accounts list.`,
        'Log Out Account',
        {
          confirmButtonText: 'Log Out',
          cancelButtonText: 'Cancel',
          type: 'warning',
          confirmButtonClass: 'el-button--danger'
        }
      ).then(() => {
        try {
          const isCurrentAccount = account.id === this.currentAccountId

          // Remove account from multiAccountManager
          // The removeAccount method handles switching to another account if needed
          const success = multiAccountManager.removeAccount(account.id)

          if (success) {
            if (isCurrentAccount) {
              const remainingAccounts = multiAccountManager.getAllAccounts()
              if (remainingAccounts.length > 0) {
                // multiAccountManager already switched to another account
                // Update Vuex state to reflect the new account
                const newAccountId = multiAccountManager.getCurrentAccountId()
                this.$store.dispatch('switchAccount', newAccountId).then(() => {
                  this.$message.success('Account logged out. Switched to another account.')
                  this.switchAccountDialogVisible = false
                  setTimeout(() => {
                    location.reload()
                  }, 500)
                })
              } else {
                // No accounts left, full logout
                this.$store.dispatch('logOut').then(() => {
                  this.$message.success('Account logged out successfully')
                  this.switchAccountDialogVisible = false
                  location.reload()
                })
              }
            } else {
              // Just removed a non-current account from the list
              this.$message.success('Account logged out successfully')
              // Refresh the account list in the dialog
              this.availableAccounts = multiAccountManager.getAllAccounts()
              this.currentAccountId = multiAccountManager.getCurrentAccountId()
            }
          } else {
            this.$message.error('Failed to log out account')
          }
        } catch (error) {
          console.error('Error logging out account:', error)
          this.$message.error('Failed to log out account')
        }
      }).catch(() => {
        // User cancelled
      })
    }
  }
}
</script>

<style scoped>
.home-container {
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 60px;
}

.nav-menu {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
  overflow: hidden;
}

.nav-menu >>> .el-menu-item {
  padding: 0 14px;
  font-size: 13px;
  flex-shrink: 0;
}

.nav-menu-hidden {
  transform: translateY(-100%);
}

.nav-hover-zone {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 20px;
  z-index: 1001;
  background: transparent;
}

.home-container.nav-hidden {
  padding-top: 0;
}

.logo-item {
  height: 60px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.logo-container {
  height: 60px;
  display: flex;
  align-items: center;
}

.logo-link {
  text-decoration: none;
  color: inherit;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-img {
  height: 32px;
  width: auto;
}

.logo-text {
  font-size: 18px;
  font-weight: bold;
  color: #1159AF;
  display: inline-block;
  white-space: nowrap;
}

.user-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
  min-width: 0;
  max-width: 200px;
}

.user-dropdown-link:hover {
  background-color: #f5f7fa;
}

.user-name {
  margin: 0 8px;
  color: #606266;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subscription-badge {
  margin-right: 4px;
  font-size: 10px;
  padding: 0 4px;
  height: 18px;
  line-height: 16px;
}

.achievement-section {
  padding: 16px;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 8px;
}

.achievement-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.achievement-stats {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.achievement-stat-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 6px;
  transition: all 0.2s;
}

.achievement-stat-item:hover {
  background: #ecf5ff;
  transform: translateX(2px);
}

.achievement-stat-item i {
  font-size: 18px;
  color: #409EFF;
  flex-shrink: 0;
}

.stat-label {
  font-size: 13px;
  color: #606266;
  flex: 1;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-left: auto;
}

.creator-level-display {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 5px;
}

.creator-label-text {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.el-dropdown-menu {
  padding: 5px 0;
  min-width: 240px;
  max-width: 320px;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-dropdown-menu__item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 16px;
  text-align: left;
  white-space: nowrap;
  line-height: 1.4;
  min-height: 36px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.el-dropdown-menu__item i {
  margin-right: 12px;
  width: 16px;
  text-align: center;
  flex-shrink: 0;
  color: #606266;
  font-size: 16px;
}

.custom-icon {
  margin-right: 12px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #606266;
  vertical-align: middle;
}

.heartbeat-icon {
  width: 20px;
  height: 20px;
}

.menu-divider {
  display: flex;
  width: 1px;
  height: 30px;
  background-color: #DCDFE6;
  margin: 0 4px;
  align-self: center;
  flex-shrink: 0;
}

.dropdown-divider {
  height: 1px;
  margin: 5px 0;
  overflow: hidden;
  background-color: #e4e7ed;
  list-style: none;
}

.creator-menu-item {
  font-weight: 600;
  color: #1159AF !important;
}

.creator-menu-item span {
  font-weight: 600;
}





.el-avatar {
  background-color: white;
  color: #409EFF;
  flex-shrink: 0;
}

.user-menu-item {
  padding: 0 12px;
  height: 60px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.3s;
  flex-shrink: 0;
}
.user-menu-item:hover {
  background: #f5f7fa;
}

.account-list {
  max-height: 400px;
  overflow-y: auto;
  padding: 5px 0;
}

.account-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.3s;
  cursor: pointer;
}

.account-item:hover {
  background-color: #f5f7fa;
}

.account-item:last-child {
  margin-bottom: 0;
}

.account-info {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  flex: 1;
  min-width: 0;
}

.account-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-email {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-type {
  font-size: 11px;
  color: #c0c4cc;
  margin-top: 2px;
}

.account-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.account-more-btn {
  padding: 5px;
  font-size: 18px;
  color: #909399;
  transition: color 0.3s;
}

.account-more-btn:hover {
  color: #606266;
}

.no-accounts {
  text-align: center;
  padding: 40px 20px;
}

.new-account-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.search-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  height: 60px;
}

.search-container .el-input {
  margin: 0;
}

.search-container .el-input__inner {
  border-radius: 20px;
  border: 1px solid #DCDFE6;
  transition: all 0.3s;
}

.search-container .el-input__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.search-container .el-input__prefix {
  left: 12px;
}

/* Search Bar Styles */
.search-bar-container {
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 60px;
  flex-shrink: 1;
  min-width: 0;
}

.search-input {
  width: 200px;
  min-width: 140px;
}

.search-input >>> .el-input__inner {
  border-radius: 20px;
  border: 1px solid #DCDFE6;
  transition: all 0.3s;
}

.search-input >>> .el-input__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
</style>
